import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import dataTestValue from 'src/utils/testUtils';

export const GenericComponentWrapper = ({
    name,
    label,
    value,
    children
}: PropsWithChildren<{
    name: string;
    label?: string;
    value?: any | null;
}>): JSX.Element => (
    <div
        className={classNames([
            'element',
            {
                empty: value === null || value === undefined,
                error: false,
                required: false,
                hasLabel: label
            }
        ])}
        data-test={dataTestValue(name)}
    >
        {children}
        {label === undefined ? null : <label>{label}</label>}
    </div>
);
